import _ from '@/utils/lodash-optimized'
import React from 'react'
import { connect } from 'react-redux'
import statuses from 'shared_src/dictionaries/episodeOfCare/statuses'

import * as Compartment from '../../../selectors/compartment'
import { FriendlyDateTime } from '../../shared/Date/friendly-date-time'
import { CancelButton } from '../../shared/FormBuilder'
import MagicGrid from '../../shared/MagicGrid'
import { Modal } from '../../shared/NarusMaterial'

import {
  hideCaseManagementModal,
  updateCase,
  updateOrganization
} from './actions'
import CaseManagementForm from './caseform'
import NotesEdit from './noteEdit'
import OrganizationForm from './orgform'

const headers = [
  {
    displayFn: i => _.find(statuses, x => x.value === i.status).label,
    title: 'Status'
  },
  {
    displayFn: ({ period }) => <FriendlyDateTime datetime={period.start} />,
    title: 'Start',
    sortBy: 'period.start'
  },
  {
    displayFn: ({ period }) => <FriendlyDateTime datetime={period.end} />,
    title: 'End',
    sortBy: 'period.end'
  },
  {
    displayFn: i =>
      _.chain(i)
        .get('extension', [])
        .find(
          v =>
            v.url === 'http://narushealth.com/fhir/episodeofcare-practitioner',
          {}
        )
        .get('valueReference.display', '')
        .value(),
    title: 'Author'
  },
  {
    displayFn: (row, i, rows) => (
      <NotesEdit
        note={row}
        notes={rows}
      />
    ),
    title: 'Notes'
  }
]

class CaseManagementModal extends React.Component {
  constructor (props) {
    super(props)
    this.handleSubmitCase = this.handleSubmitCase.bind(this)
    this.handleSubmitOrg = this.handleSubmitOrg.bind(this)
  }

  handleSubmitCase (value) {
    const { dispatch } = this.props
    dispatch(updateCase(value))
  }

  handleSubmitOrg (value) {
    const { dispatch } = this.props
    dispatch(updateOrganization(value))
  }

  render () {
    const {
      dispatch,
      episodeOfCare: { statusHistory = [] },
      caseClosure
    } = this.props
    return (
      caseClosure.showModal && (
        <Modal title='Case Management'>
          <CaseManagementForm
            formKey='caseManagement'
            onSubmit={this.handleSubmitCase}
          />

          <h2> Managing Organization </h2>
          <OrganizationForm
            formKey='managingOrganization'
            onSubmit={this.handleSubmitOrg}
            disabled={false}
          />
          <h2> Status History </h2>
          <MagicGrid
            className='nh-status-history-table'
            headers={headers}
            rows={statusHistory}
            sortOn={1}
          />
          <div className='modal-actions end-xs'>
            <CancelButton
              formKey='caseManagement'
              onClick={() => dispatch(hideCaseManagementModal())}
            />
          </div>
        </Modal>
      )
    )
  }
}

const mapStateToProps = redux => ({
  episodeOfCare: Compartment.episodeOfCare(redux) || {},
  caseClosure: redux.caseClosure
})

export default connect(mapStateToProps)(CaseManagementModal)
